import React, { useState } from 'react';

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';
import {
  renderThumb,
  renderTrack,
  renderView,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from 'prop-types';

// Assets
import { IoMenuOutline } from 'react-icons/io5';

function Sidebar(props) {
  const { routes, sidebarPos, toggleSidebarPos, mouseOver, toggleMouseOver } =
    props;
  // const [openSidebar, setOpenSidebar] = useState(false);

  // const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  let variantChange = '0.1s linear';
  let shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
    'unset'
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue('white', 'navy.800');
  let menuColor = useColorModeValue('gray.400', 'white');
  let sidebarMargins = '0px';

  // SIDEBAR
  return (
    <Flex display={{ sm: 'none', xl: 'block' }}>
      <Box
        position='fixed'
        minH='100%'>
        <Box
          bg={sidebarBg}
          transition={variantChange}
          w={sidebarPos || mouseOver ? '300px' : '56px'}
          h='100vh'
          m={sidebarMargins}
          minH='100%'
          overflowX='hidden'
          boxShadow={shadow}>
          <Flex
            ref={btnRef}
            w='max-content'
            h='max-content'
            // bgColor='red'
            mt={3}
            ml={3}
            mb={-5}
            onClick={toggleSidebarPos}>
            <Icon
              as={IoMenuOutline}
              color={menuColor}
              style={{ zIndex: 1 }}
              my='auto'
              w='34px'
              h='34px'
              me='10px'
              _hover={{ cursor: 'pointer' }}
            />
          </Flex>
          <Scrollbars
            onMouseEnter={toggleMouseOver}
            onMouseLeave={toggleMouseOver}
            autoHide
            renderTrackVertical={renderTrack}
            renderThumbVertical={renderThumb}
            renderView={renderView}>
            <Content
              routes={routes}
              sidebarPos={sidebarPos}
              mouseOver={mouseOver}
            />
          </Scrollbars>
        </Box>
      </Box>
    </Flex>
  );
}

// FUNCTIONS
export function SidebarResponsive(props) {
  let sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
  let menuColor = useColorModeValue('gray.400', 'white');
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { routes } = props;
  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex
      display={{ sm: 'flex', xl: 'none' }}
      alignItems='center'>
      <Flex
        ref={btnRef}
        w='max-content'
        h='max-content'
        onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my='auto'
          w='20px'
          h='20px'
          me='10px'
          _hover={{ cursor: 'pointer' }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
        finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent
          w='285px'
          maxW='285px'
          bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex='3'
            onClose={onClose}
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
          />
          <DrawerBody
            maxW='285px'
            px='0rem'
            pb='0'>
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}>
              <Content
                routes={routes}
                sidebarPos={true}
              />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
